var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "lg": "8"
    }
  }, [_c('iq-card', {
    attrs: {
      "body-class": "pb-0"
    },
    scopedSlots: _vm._u([{
      key: "headerTitle",
      fn: function fn() {
        return [_c('h4', {
          staticClass: "text-primary font-semibold"
        }, [_vm._v("General Information")])];
      },
      proxy: true
    }, {
      key: "body",
      fn: function fn() {
        var _vm$fleetData, _vm$fleetData2, _vm$fleetData3, _vm$fleetData3$status, _vm$fleetData$name, _vm$fleetData4, _vm$fleetData$vehicle, _vm$fleetData5, _vm$fleetData5$vehicl, _vm$fleetData$company, _vm$fleetData6, _vm$fleetData6$compan, _vm$fleetData$code, _vm$fleetData$deliver, _vm$fleetData7, _vm$fleetData$ownersh, _vm$fleetData$dimensi, _vm$fleetData$dimensi2, _vm$fleetData$dimensi3, _vm$fleetData$dimensi4, _vm$fleetData$dimensi5;
        return [_c('b-row', [_c('b-col', {
          attrs: {
            "md": "5"
          }
        }, [_c('div', {
          staticStyle: {
            "position": "relative"
          }
        }, [_c('div', {
          staticClass: "user-profile text-center overflow-hidden",
          staticStyle: {
            "position": "relative"
          }
        }, [_c('b-badge', {
          staticClass: "px-4 py-1 rounded-none",
          staticStyle: {
            "min-width": "120px",
            "position": "absolute",
            "right": "-28px",
            "top": "24px",
            "rotate": "45deg"
          },
          attrs: {
            "variant": _vm.getStatusColor((_vm$fleetData = _vm.fleetData) === null || _vm$fleetData === void 0 ? void 0 : _vm$fleetData.status)
          }
        }, [_vm._v(" " + _vm._s((_vm$fleetData2 = _vm.fleetData) !== null && _vm$fleetData2 !== void 0 && _vm$fleetData2.status ? (_vm$fleetData3 = _vm.fleetData) === null || _vm$fleetData3 === void 0 ? void 0 : (_vm$fleetData3$status = _vm$fleetData3.status) === null || _vm$fleetData3$status === void 0 ? void 0 : _vm$fleetData3$status.replace(/_/g, ' ') : '-') + " ")]), [_vm.fleetData.img !== null || _vm.fleetData.img !== 'null' || _vm.fleetData.img !== 'undefined' ? _c('img', {
          staticClass: "img-fluid",
          staticStyle: {
            "border-radius": "12px"
          },
          attrs: {
            "src": _vm.fleetData.vehicleType.icon.url,
            "alt": ""
          }
        }) : _c('img', {
          staticClass: "img-fluid",
          staticStyle: {
            "border-radius": "12px"
          },
          attrs: {
            "src": _vm.fleetData.img,
            "alt": ""
          }
        })]], 2), _c('div', {
          staticClass: "w-100 d-flex justify-content-between align-items-center p-3",
          staticStyle: {
            "position": "absolute",
            "bottom": "0",
            "z-index": "2"
          }
        }, [_c('div', [_c('div', {
          staticClass: "d-flex"
        }, [_c('img', {
          staticClass: "mr-2",
          attrs: {
            "src": "https://flagsapi.com/ID/shiny/24.png",
            "alt": "flags"
          }
        }), _c('h5', {
          staticClass: "text-white"
        }, [_c('strong', [_vm._v(_vm._s((_vm$fleetData$name = (_vm$fleetData4 = _vm.fleetData) === null || _vm$fleetData4 === void 0 ? void 0 : _vm$fleetData4.name) !== null && _vm$fleetData$name !== void 0 ? _vm$fleetData$name : '-'))])])]), _c('div', {
          staticClass: "d-flex align-items-center"
        }, [_c('p', {
          staticClass: "text-sm m-0 text-white"
        }, [_vm._v(" " + _vm._s((_vm$fleetData$vehicle = (_vm$fleetData5 = _vm.fleetData) === null || _vm$fleetData5 === void 0 ? void 0 : (_vm$fleetData5$vehicl = _vm$fleetData5.vehicleType) === null || _vm$fleetData5$vehicl === void 0 ? void 0 : _vm$fleetData5$vehicl.name) !== null && _vm$fleetData$vehicle !== void 0 ? _vm$fleetData$vehicle : '-') + " ")]), _c('div', {
          staticClass: "mx-2",
          staticStyle: {
            "height": "6px",
            "width": "6px",
            "border-radius": "50%",
            "background-color": "white"
          }
        }), _c('p', {
          staticClass: "text-sm m-0 text-white"
        }, [_vm._v(" " + _vm._s((_vm$fleetData$company = (_vm$fleetData6 = _vm.fleetData) === null || _vm$fleetData6 === void 0 ? void 0 : (_vm$fleetData6$compan = _vm$fleetData6.company) === null || _vm$fleetData6$compan === void 0 ? void 0 : _vm$fleetData6$compan.company) !== null && _vm$fleetData$company !== void 0 ? _vm$fleetData$company : '-') + " ")])])]), _c('b-dropdown', {
          attrs: {
            "size": "sm",
            "text": "Small",
            "variant": "none",
            "right": "",
            "no-caret": ""
          }
        }, [_c('template', {
          slot: "button-content"
        }, [_c('div', [_c('i', {
          staticClass: "fa fa-ellipsis-h cursor-pointer text-white",
          staticStyle: {
            "rotate": "90deg",
            "margin-right": "-12px"
          }
        })])]), _vm.permissionEditFleet ? _c('b-dropdown-item', {
          attrs: {
            "variant": "primary"
          },
          on: {
            "click": function click($event) {
              return _vm.fetchFleetDetail(_vm.fleetData.id);
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-edit"
        }), _vm._v(" Edit ")]) : _vm._e(), _vm.permissionDeleteFleet ? _c('b-dropdown-item', {
          attrs: {
            "variant": "danger"
          },
          on: {
            "click": function click($event) {
              return _vm.onDeleteFleet(_vm.fleetData);
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-trash"
        }), _vm._v(" Delete ")]) : _vm._e()], 2)], 1)])]), _c('b-col', {
          attrs: {
            "md": "7"
          }
        }, [_c('div', {
          staticClass: "w-100"
        }, [_c('table', {
          staticClass: "table table-striped w-100"
        }, [_c('tbody', [_c('tr', [_c('td', {
          attrs: {
            "width": "35%"
          }
        }, [_vm._v("Call Sign")]), _c('td', {
          staticClass: "font-semibold",
          attrs: {
            "width": "65%"
          }
        }, [_vm.fleetData.code === null || _vm.fleetData.code === 'null' || _vm.fleetData.code === 'undefined' ? [_vm._v(" - ")] : [_vm._v(" " + _vm._s((_vm$fleetData$code = _vm.fleetData.code) !== null && _vm$fleetData$code !== void 0 ? _vm$fleetData$code : '-') + " ")]], 2)]), _c('tr', [_c('td', {
          attrs: {
            "width": "35%"
          }
        }, [_vm._v("Effective Date")]), _c('td', {
          staticClass: "font-semibold",
          attrs: {
            "width": "65%"
          }
        }, [_vm._v(" " + _vm._s((_vm$fleetData$deliver = (_vm$fleetData7 = _vm.fleetData) === null || _vm$fleetData7 === void 0 ? void 0 : _vm$fleetData7.deliveryDate) !== null && _vm$fleetData$deliver !== void 0 ? _vm$fleetData$deliver : '-') + " ")])]), _c('tr', [_c('td', [_vm._v("Ownership")]), _c('td', {
          staticClass: "font-semibold"
        }, [_vm.fleetData.ownership === null || _vm.fleetData.ownership === 'null' || _vm.fleetData.ownership === 'undefined' ? [_vm._v(" - ")] : [_vm._v(" " + _vm._s((_vm$fleetData$ownersh = _vm.fleetData.ownership) !== null && _vm$fleetData$ownersh !== void 0 ? _vm$fleetData$ownersh : '-') + " ")]], 2)]), _c('tr', [_c('td', {
          attrs: {
            "width": "35%"
          }
        }, [_vm._v("Year Build / Country")]), _c('td', {
          staticClass: "font-semibold",
          attrs: {
            "width": "65%"
          }
        }, [_vm.fleetData.yearBuildCountry === null || _vm.fleetData.yearBuildCountry === 'null' || _vm.fleetData.yearBuildCountry === 'undefined' ? [_vm._v(" - ")] : [_vm._v(" " + _vm._s(_vm.fleetData.yearBuildCountry) + " ")]], 2)])])])])]), _c('b-col', {
          staticClass: "mb-4 mt-3",
          attrs: {
            "md": "12"
          }
        }, [_c('table', {
          staticClass: "table mt-0 mb-2 table-striped table-box-shadow"
        }, [_c('thead', [_c('tr', [_c('th', {
          attrs: {
            "colspan": "2"
          }
        }, [_vm._v("Dimensions")])])]), _c('tbody', [_c('tr', [_c('td', {
          staticClass: "w-50"
        }, [_vm._v("Length")]), _c('td', {
          staticClass: "w-50 font-semibold"
        }, [_vm._v(" " + _vm._s((_vm$fleetData$dimensi = (_vm$fleetData$dimensi2 = _vm.fleetData.dimension) === null || _vm$fleetData$dimensi2 === void 0 ? void 0 : _vm$fleetData$dimensi2.length.meter) !== null && _vm$fleetData$dimensi !== void 0 ? _vm$fleetData$dimensi : '-') + " Meter ")])]), _c('tr', [_c('td', {
          staticClass: "w-50"
        }, [_vm._v("Width")]), _c('td', {
          staticClass: "font-semibold w-50"
        }, [_vm._v(" " + _vm._s((_vm$fleetData$dimensi3 = _vm.fleetData.dimension.width.meter) !== null && _vm$fleetData$dimensi3 !== void 0 ? _vm$fleetData$dimensi3 : '-') + " Meter ")])]), _c('tr', [_c('td', {
          staticClass: "w-50"
        }, [_vm._v("Depth")]), _c('td', {
          staticClass: "font-semibold"
        }, [_vm._v(" " + _vm._s((_vm$fleetData$dimensi4 = _vm.fleetData.dimension.depth.meter) !== null && _vm$fleetData$dimensi4 !== void 0 ? _vm$fleetData$dimensi4 : '-') + " Meter ")])]), _c('tr', [_c('td', {
          staticClass: "w-50"
        }, [_vm._v("Draft")]), _c('td', {
          staticClass: "font-semibold"
        }, [_vm._v(" " + _vm._s((_vm$fleetData$dimensi5 = _vm.fleetData.dimension.draft.meter) !== null && _vm$fleetData$dimensi5 !== void 0 ? _vm$fleetData$dimensi5 : '-') + " Meter ")])])])])]), _c('b-col', {
          staticClass: "mb-4",
          attrs: {
            "md": "12"
          }
        }, [_c('table', {
          staticClass: "table table-striped"
        }, [_c('thead', [_c('th', {
          attrs: {
            "colspan": "2"
          }
        }, [_vm._v("Power Information")])]), _c('tbody', [_c('tr', [_c('td', {
          staticClass: "w-50 font-semibold"
        }, [_vm._v("Power Type")]), _c('td', {
          staticClass: "w-50 font-semibold"
        }, [_vm._v("Series")])]), _vm._l(_vm.fleetData.powers, function (pwr, index) {
          var _pwr$powerType$name, _pwr$powerType, _pwr$powerSeries$name, _pwr$powerSeries, _pwr$powerSeries$mode, _pwr$powerSeries2;
          return _c('tr', {
            key: index
          }, [_c('td', {
            staticClass: "w-50 font-semibold"
          }, [_vm._v(" " + _vm._s((_pwr$powerType$name = (_pwr$powerType = pwr.powerType) === null || _pwr$powerType === void 0 ? void 0 : _pwr$powerType.name) !== null && _pwr$powerType$name !== void 0 ? _pwr$powerType$name : '-') + " ")]), _c('td', {
            staticClass: "w-50 font-semibold"
          }, [_vm._v(" " + _vm._s((_pwr$powerSeries$name = (_pwr$powerSeries = pwr.powerSeries) === null || _pwr$powerSeries === void 0 ? void 0 : _pwr$powerSeries.name) !== null && _pwr$powerSeries$name !== void 0 ? _pwr$powerSeries$name : '-') + " - " + _vm._s((_pwr$powerSeries$mode = (_pwr$powerSeries2 = pwr.powerSeries) === null || _pwr$powerSeries2 === void 0 ? void 0 : _pwr$powerSeries2.model) !== null && _pwr$powerSeries$mode !== void 0 ? _pwr$powerSeries$mode : '-') + " ")])]);
        })], 2)])]), _c('b-col', {
          attrs: {
            "md": "12"
          }
        }, [_c('table', {
          staticClass: "table table-striped"
        }, [_c('thead', [_c('tr', [_c('th', {
          attrs: {
            "colspan": "2"
          }
        }, [_vm._v("Capcity Information")])])]), _c('tbody', [_c('tr', [_c('td', {
          staticClass: "w-50 font-semibold"
        }, [_vm._v("Type")]), _c('td', {
          staticClass: "w-50 font-semibold"
        }, [_vm._v("Series")])]), _vm._l(_vm.fleetData.robs, function (pwr, index) {
          var _pwr$robType$name, _pwr$robType, _pwr$robSeries$name, _pwr$robSeries;
          return _c('tr', {
            key: index
          }, [_c('td', [_vm._v(_vm._s((_pwr$robType$name = (_pwr$robType = pwr.robType) === null || _pwr$robType === void 0 ? void 0 : _pwr$robType.name) !== null && _pwr$robType$name !== void 0 ? _pwr$robType$name : '-'))]), _c('td', [_vm._v(_vm._s((_pwr$robSeries$name = (_pwr$robSeries = pwr.robSeries) === null || _pwr$robSeries === void 0 ? void 0 : _pwr$robSeries.name) !== null && _pwr$robSeries$name !== void 0 ? _pwr$robSeries$name : '-'))])]);
        })], 2)])])], 1)];
      },
      proxy: true
    }])
  })], 1), _c('b-col', {
    attrs: {
      "lg": "4"
    }
  }, [_c('iq-card', {
    attrs: {
      "class-name": "iq-card-block iq-card-stretch iq-cad-height"
    },
    scopedSlots: _vm._u([{
      key: "headerTitle",
      fn: function fn() {
        return [_c('h4', {
          staticClass: "text-primary font-semibold"
        }, [_vm._v("Active Crew")])];
      },
      proxy: true
    }, {
      key: "body",
      fn: function fn() {
        var _vm$filteredCrews;
        return [_c('div', [_c('b-form-input', {
          staticClass: "mb-3",
          attrs: {
            "placeholder": "Search crew name"
          },
          model: {
            value: _vm.searchCrew,
            callback: function callback($$v) {
              _vm.searchCrew = $$v;
            },
            expression: "searchCrew"
          }
        })], 1), _c('div', {
          staticClass: "overflow-auto",
          staticStyle: {
            "height": "420px",
            "position": "relative"
          }
        }, [_c('table', {
          staticClass: "table table-striped"
        }, [_c('thead', [_c('tr', {
          staticStyle: {
            "position": "sticky",
            "width": "100%",
            "top": "0"
          }
        }, [_c('th', {
          staticStyle: {
            "width": "60%"
          }
        }, [_vm._v("Crew Name")]), _c('th', {
          staticStyle: {
            "width": "40%"
          }
        }, [_vm._v("Seaferer Code")])])]), !_vm.loadingActiveCrew ? _c('tbody', [(_vm$filteredCrews = _vm.filteredCrews) !== null && _vm$filteredCrews !== void 0 && _vm$filteredCrews.length ? _vm._l(_vm.filteredCrews, function (crew, index) {
          var _crew$position$name, _crew$position;
          return _c('tr', {
            key: crew.id
          }, [_c('td', {
            staticStyle: {
              "width": "60%"
            }
          }, [_c('div', {
            staticClass: "d-flex align-items-center",
            on: {
              "click": function click($event) {
                return _vm.$router.push({
                  path: "/crewing/profile",
                  query: {
                    user: 'crew',
                    id: crew.id
                  }
                });
              }
            }
          }, [_c('img', {
            staticClass: "rounded-circle avatar-40 mr-2",
            attrs: {
              "src": crew !== null && crew !== void 0 && crew.photo ? crew === null || crew === void 0 ? void 0 : crew.photo : _vm.$getInitials(crew === null || crew === void 0 ? void 0 : crew.fullname),
              "alt": "crew-photo"
            }
          }), _c('div', [_c('p', {
            staticClass: "mb-0 font-semibold"
          }, [_vm._v(" " + _vm._s(crew === null || crew === void 0 ? void 0 : crew.fullname) + " ")]), _c('small', [_vm._v(_vm._s((_crew$position$name = crew === null || crew === void 0 ? void 0 : (_crew$position = crew.position) === null || _crew$position === void 0 ? void 0 : _crew$position.name) !== null && _crew$position$name !== void 0 ? _crew$position$name : '-'))])])])]), _c('td', {
            staticStyle: {
              "width": "40%"
            }
          }, [_vm._v(" " + _vm._s((crew === null || crew === void 0 ? void 0 : crew.seaferer_code) || '-') + " ")])]);
        }) : [_c('tr', [_c('td', {
          attrs: {
            "colspan": "2",
            "align": "center"
          }
        }, [_vm._v("No data available")])])]], 2) : _vm._e()]), _vm.loadingActiveCrew ? _c('div', {
          staticClass: "d-flex justify-content-center my-5"
        }, [_c('b-spinner')], 1) : _vm._e()])];
      },
      proxy: true
    }])
  }), _c('iq-card', {
    scopedSlots: _vm._u([{
      key: "headerTitle",
      fn: function fn() {
        return [_c('h4', {
          staticClass: "text-primary font-semibold"
        }, [_vm._v("Support Document")])];
      },
      proxy: true
    }, {
      key: "body",
      fn: function fn() {
        return [_c('div', {
          staticClass: "overflow-auto",
          staticStyle: {
            "position": "relative",
            "max-height": "280px"
          }
        }, [_c('table', {
          staticClass: "table"
        }, [_c('tbody', [_vm._l(_vm.fleetData.docs, function (doc, index) {
          var _doc$fileName;
          return _c('tr', {
            key: index
          }, [_c('td', {
            staticStyle: {
              "width": "70%"
            }
          }, [_vm._v(" " + _vm._s((_doc$fileName = doc === null || doc === void 0 ? void 0 : doc.fileName) !== null && _doc$fileName !== void 0 ? _doc$fileName : '-') + " ")]), _c('td', {
            staticClass: "text-center"
          }, [_c('button', {
            staticClass: "btn btn-outline-primary btn-sm d-flex align-items-center",
            on: {
              "click": function click($event) {
                return _vm.handleOpenFile(doc.url);
              }
            }
          }, [_vm._v(" Download "), _c('i', {
            staticClass: "ri-download-2-line ml-1"
          })])])]);
        }), _vm.fleetData.docs.length === 0 ? _c('tr', [_c('td', {
          staticClass: "text-center text-muted",
          attrs: {
            "colspan": "3"
          }
        }, [_vm._v(" No documents found ")])]) : _vm._e()], 2)])])];
      },
      proxy: true
    }])
  })], 1), _c('b-col', {
    attrs: {
      "lg": "12"
    }
  }, [_c('iq-card', {
    attrs: {
      "body-class": "pb-0"
    },
    scopedSlots: _vm._u([{
      key: "headerTitle",
      fn: function fn() {
        return [_c('h4', {
          staticClass: "text-primary font-semibold"
        }, [_vm._v("Fleet Summary")])];
      },
      proxy: true
    }, {
      key: "body",
      fn: function fn() {
        var _vm$fleetData8, _vm$fleetData9;
        return [_c('div', {
          staticClass: "d-flex gap-2 mb-4 overflow-auto pb-3"
        }, _vm._l(_vm.tabs, function (tab) {
          return _c('div', {
            key: tab.key,
            staticClass: "tab-btn px-4 py-2 mr-2 text-nowrap",
            class: {
              active: _vm.activeTab === tab.key
            },
            on: {
              "click": function click($event) {
                _vm.activeTab = tab.key;
              }
            }
          }, [_vm._v(" " + _vm._s(tab.title) + " ")]);
        }), 0), _c('div', [_vm.activeTab === 'operational' ? _c('div', [_c('Operational', {
          attrs: {
            "isChildComponent": true
          }
        })], 1) : _vm._e(), _vm.activeTab === 'certificate' ? _c('div', [_c('Certificate', {
          attrs: {
            "isChildComponent": true
          }
        })], 1) : _vm._e(), _vm.activeTab === 'maintenance-board' ? _c('div', [_c('MaintenanceFleetDetail')], 1) : _vm._e(), _vm.activeTab === 'service-repair' ? _c('div', [_c('ServiceRepairSummary', {
          attrs: {
            "fleetId": _vm.$route.query.vehicleId
          }
        })], 1) : _vm._e(), _vm.activeTab === 'list-initial' ? _c('div', [_c('ListInitialTable', {
          attrs: {
            "vehicle-id": _vm.vehicleId
          }
        })], 1) : _vm._e(), _vm.activeTab === 'recommendation' ? _c('div', [_c('ListInitialRecommendation', {
          attrs: {
            "vehicle-id": _vm.vehicleId
          }
        })], 1) : _vm._e(), _vm.activeTab === 'crewing' ? _c('div', [_c('div', {
          staticClass: "iq-edit-list"
        }, [_c('div', {
          staticClass: "d-flex"
        }, [_c('div', {
          staticClass: "tab-btn flex-fill text-center",
          class: {
            active: _vm.activeSubTab === 'active_crew'
          },
          on: {
            "click": function click($event) {
              _vm.activeSubTab = 'active_crew';
            }
          }
        }, [_vm._v(" CREW ACTIVE " + _vm._s((_vm$fleetData8 = _vm.fleetData) === null || _vm$fleetData8 === void 0 ? void 0 : _vm$fleetData8.name) + " (CURRENT) ")]), _c('div', {
          staticClass: "tab-btn flex-fill text-center",
          class: {
            active: _vm.activeSubTab === 'history_crew'
          },
          on: {
            "click": function click($event) {
              _vm.activeSubTab = 'history_crew';
            }
          }
        }, [_vm._v(" HISTORY CREW " + _vm._s((_vm$fleetData9 = _vm.fleetData) === null || _vm$fleetData9 === void 0 ? void 0 : _vm$fleetData9.name) + " ")])]), _c('div', {
          staticClass: "tab-content mt-3"
        }, [_vm.activeSubTab === 'active_crew' ? _c('div') : _vm._e(), _vm.activeSubTab === 'history_crew' ? _c('div') : _vm._e()])])]) : _vm._e()])];
      },
      proxy: true
    }])
  })], 1)], 1), _c('b-modal', {
    attrs: {
      "id": "edit-fleet",
      "size": "xl",
      "no-close-on-backdrop": true,
      "header-bg-variant": _vm.modal.headerBgVariant,
      "header-text-variant": _vm.modal.headerTextVariant,
      "body-bg-variant": _vm.modal.bodyBgVariant,
      "body-text-variant": _vm.modal.bodyTextVariant,
      "hide-footer": ""
    },
    scopedSlots: _vm._u([{
      key: "modal-header",
      fn: function fn(_ref) {
        var close = _ref.close;
        return [_c('h5', [_vm._v("Edit Your Fleet")]), _c('b-button', {
          attrs: {
            "size": "md",
            "variant": "outline-danger"
          },
          on: {
            "click": close
          }
        }, [_c('i', {
          staticClass: "fa fa-times"
        }), _vm._v(" Close ")])];
      }
    }])
  }, [_c('AddFleet', {
    attrs: {
      "formData": _vm.fleetDetail
    },
    on: {
      "childAction": function childAction($event) {
        return _vm.$bvModal.hide('edit-fleet');
      }
    }
  })], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }